import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import 'datatables.net-bs5';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import HelpSite from "../../../Common/HelpLink";
import PurchaseOrderService from "../../Controller/PurchaseOrderController";
import $ from 'jquery';
function PurchaseOrderHistory({ PurchaseOrderID }) {

    const navigate = useNavigate();
    const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
    };
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    };
    const tableRef = useRef();
    const [PurchaseHistoryList, setPurchaseHistory] = useState([]);
    const initDataTable = () => {
        if ($.fn.DataTable.isDataTable(tableRef.current)) {
            $(tableRef.current).DataTable().destroy();
        }
        $(tableRef.current).DataTable({
            "paging": true,
            "searching": true,
            "info": true,
            order: [[0, 'desc']],
        });
    };
    const fetchPurchaseHistory = async () => {
        try {

            const data = await PurchaseOrderService.GetPurchaseHistory(redirectCallback, PurchaseOrderID);
            setPurchaseHistory(data);
        } catch (error) {
            console.error('Error fetching Contacts:', error);
        }
    };

    useEffect(() => {
        if (PurchaseOrderID > 0) {
            fetchPurchaseHistory();
        }
    }, [PurchaseOrderID]);
    return (
        <div>
            <div className="row mb-3" style={{ marginLeft: "-5px" }}>
                <div className="col-sm-12" style={{ "textAlign": "right" }}>

                </div>
            </div>
            <div className="row mb-3" style={{ marginLeft: "-5px" }}>
                <div className="col-sm-12">
                    <div className="" >
                        <table className="table m-0 table-hover" ref={tableRef}>
                            <thead>
                                <tr>
                                    <th className="no-wrap">Created</th>
                                    <th className="no-wrap">Invoice No.</th>
                                    <th className="no-wrap">GRN No.</th>
                                    <th className="no-wrap">Invoice/GRN Date</th>
                                    <th className="no-wrap">Amount (Net)</th>
                                    <th className="no-wrap">Amount (VAT)</th>
                                    <th className="no-wrap">Delivery (Net)</th>
                                    <th className="no-wrap">Delivery (VAT)</th>
                                </tr>
                            </thead>
                            <tbody>
                                {PurchaseHistoryList.map((purchase) => (
                                    <tr key={purchase.PK_PurchaseHistory_ID}>
                                        <td className="no-wrap">{formatDate(purchase.dt_Created)}</td>
                                        <td className="no-wrap">{purchase.vc_InvoiceNo}</td>
                                        <td className="no-wrap">{purchase.bnt_OurGRNNumber}</td>
                                        <td className="no-wrap">{formatDate(purchase.dt_InvoiceDate)}</td>
                                        <td className="no-wrap">{purchase.mon_NetAmount}</td>
                                        <td className="no-wrap">{purchase.mon_VATAmount}</td>
                                        <td className="no-wrap">{purchase.mon_NetDelivery}</td>
                                        <td className="no-wrap">{purchase.mon_VATDelivery}</td>

                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PurchaseOrderHistory;
